import { CREDIT_SCHEDULES, CreditSchedule, type CreditPurchaseConfig } from '@vy/types';
import { CREDIT_PRICE_TYPES, type AddCreditForm } from './add-credit-form/add-credit-form-schema';

export function buildCreditPurchaseConfig(form: AddCreditForm): CreditPurchaseConfig {
  return {
    name: form.name,
    creditKind: form.creditKind,
    creditTypeId: form.creditTypeId,
    amount: form.amount,
    schedule: form.schedule,
    price: form.amount, // v1: sell at face value
    expiryDate: form.expiryDate ?? null,
    expirationPolicy: form.expirationPolicy ?? undefined,
  };
}

export function extractCreditFormFromCreditPurchaseConfig(item: CreditPurchaseConfig): AddCreditForm {
  const priceType = getPriceType(item.schedule);

  return {
    name: item.name,
    priceType,
    creditTypeId: item.creditTypeId,
    creditKind: item.creditKind,
    schedule: item.schedule,
    amount: item.amount,
    expiryDate: item.expiryDate != null ? new Date(item.expiryDate) : undefined,
    expirationPolicy: item.expirationPolicy ?? null,
    applyAutomatically: true,
  };
}

function getPriceType(schedule: CreditSchedule) {
  return schedule === CREDIT_SCHEDULES.ONE_TIME ? CREDIT_PRICE_TYPES.OneTime : CREDIT_PRICE_TYPES.Recurring;
}
